import { LOGGER } from '@cicero/data/utils'
import { AttributeDoc, AttributeSchema } from '../AttributeSchema'
import { AttributeValueDoc, AttributeValueSchema } from '../AttributeValueSchema'
import { Store } from '../services'
import { PageDoc } from '../PageSchema'

/**
 * Updates the values of a given attribute, deleteing or updating old values as appropriate
 * @param store 
 * @param page 
 * @param attr 
 * @param values 
 * @param changes 
 */
export const persistAttributeValueChanges = async (
  store: Store,
  page: PageDoc,
  attr: AttributeDoc,
  values: AttributeValueDoc[],
  changes: any[]
): Promise<AttributeValueDoc[]> => {
  const config = AttributeSchema.TYPE_CONFIG[attr.type]
  if (!config) { throw new Error(`Unsupported value type "${attr.type}"`) }
  if (!Array.isArray(changes)) { throw new Error(`changes must be an array, ${changes}`) }
  const indexByValue = AttributeSchema.UTILS.indexBy(values, config.valueKey as any, true)
  const toCreate: Partial<AttributeValueSchema>[] = []
  const results: AttributeValueDoc[] = []
  let changedValues = 0
  // TODO Validate if any other values have keys and delete them with a warning

  for (const change of changes) {
    const rawValue = config.parseRawValue ? config.parseRawValue(change) : change
    if (indexByValue[rawValue]) {
      results.push(indexByValue[rawValue])
      delete indexByValue[rawValue]
    } else {
      toCreate.push({
        attribute_id: attr.id,
        page_id: page.id,
        [config.valueKey]: rawValue,
      })
    }
  }

  const toDelete = Object.values(indexByValue)
  if (toDelete.length || toCreate.length) {
    const AttributeValues = store.getModel(AttributeValueSchema)
    for (let i = 0; i < Math.max(toDelete.length, toCreate.length); i++) {
      const createMe = toCreate[i]
      const deleteMe = toDelete[i]
      changedValues++
      if (createMe && deleteMe) {
        const val = await deleteMe.atomicUpdate((v) => ({ ...v, ...createMe }))
        results.push(val)
      } else if (createMe) {
        const val = await AttributeValues.CREATE(createMe as any)
        results.push(val)
      } else if (deleteMe) {
        await AttributeValues.DELETE(deleteMe.id)
      } else {
        LOGGER.warn('Managed to have neither create or delete attribute values, should be impossible')
      }
    }
  }

  LOGGER.debug('Successfully persisted changes', { toCreate, toDelete, results, changes, changedValues })
  return results
}
